export default __webpack_public_path__ + "static/media/message_box.16e5786b.png";